import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayOrganizationIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19 0.25H5C4.04 0.25 3.25 1.04 3.25 2V22C3.25 22.96 4.04 23.75 5 23.75H19C19.96 23.75 20.75 22.96 20.75 22V2C20.75 1.04 19.96 0.25 19 0.25ZM14.38 22.25H9.63V14.63H14.38V22.25ZM19.25 22C19.25 22.14 19.14 22.25 19 22.25H15.62V14C15.62 13.66 15.34 13.38 15 13.38H9C8.65 13.38 8.38 13.66 8.38 14V22.25H5C4.86 22.25 4.75 22.14 4.75 22V2C4.75 1.86 4.86 1.75 5 1.75H19C19.14 1.75 19.25 1.86 19.25 2V22Z"
        fill={color}
      />
      <path
        d="M10.5 4H7.62C7.27758 4 7 4.27758 7 4.62V5.63C7 5.97242 7.27758 6.25 7.62 6.25H10.5C10.8424 6.25 11.12 5.97242 11.12 5.63V4.62C11.12 4.27758 10.8424 4 10.5 4Z"
        fill={color}
      />
      <path
        d="M10.5 8.75H7.62C7.27758 8.75 7 9.02758 7 9.37V10.38C7 10.7224 7.27758 11 7.62 11H10.5C10.8424 11 11.12 10.7224 11.12 10.38V9.37C11.12 9.02758 10.8424 8.75 10.5 8.75Z"
        fill={color}
      />
      <path
        d="M16.38 4H13.5C13.1576 4 12.88 4.27758 12.88 4.62V5.63C12.88 5.97242 13.1576 6.25 13.5 6.25H16.38C16.7224 6.25 17 5.97242 17 5.63V4.62C17 4.27758 16.7224 4 16.38 4Z"
        fill={color}
      />
      <path
        d="M16.38 8.75H13.5C13.1576 8.75 12.88 9.02758 12.88 9.37V10.38C12.88 10.7224 13.1576 11 13.5 11H16.38C16.7224 11 17 10.7224 17 10.38V9.37C17 9.02758 16.7224 8.75 16.38 8.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayOrganizationIcon.displayName = 'PayOrganizationIcon';
